export const getPropertyName = (name: string) => {
  if (!name.includes('.')) {
    return name;
  }

  const value = name.split('.');
  return value[value.length - 1];
};
